import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";
import { ReactComponent as Quote } from "design_system/src/static/icons/quotes.svg";
import { ScalableImage, Typography } from "design_system/src";
import { TestimonialData } from "./TestimonialCard";
import styles from "./TestimonialsMobile.module.scss";
import ShowMoreCard, { ShowMoreCardProps } from "./ShowMoreCard";


interface TestimonialsMobileProps {
  testimonials: TestimonialData[];
  showSeeMorCard?: boolean;
}

const TestimonialsMobile: React.FC<TestimonialsMobileProps & ShowMoreCardProps> = ({
  testimonials,
  showSeeMorCard = false,
  reactGA
}) => {
  return (
    <div className="m_t_xxxl">
      <div className={styles.swiperContainer}>
        <Swiper
          modules={[Autoplay]}
          spaceBetween={10}
          slidesPerView={1.2}
          centeredSlides
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          loop
          grabCursor
          breakpoints={{
            600: {
              slidesPerView: 2.2,
              spaceBetween: 20,
              centeredSlides: false,
            },
            800: {
              slidesPerView: 3.2,
              spaceBetween: 20,
              centeredSlides: false,
            },
          }}
        >
          {testimonials.map(({ comment, name, role, imageUrl }, index) => (
            <SwiperSlide key={index}>
              <div className={styles.TestimonialCard}>
                <ScalableImage
                  className={styles.TestimonialCardImage}
                  src={imageUrl}
                  desktopWidth={10}
                  mobileWidth={10}
                  alt={`Testimonio de cliente Ozon – ${name}`}
                />
                <div
                  className={styles.TestimonialCardTextContainer}
                >
                  <div className={styles.TestimonialCardText}>
                    <Quote
                      className={styles.TestimonialCardQuote}
                    />
                    <Typography weight="400" scale="large" className="text_left">“{comment}”</Typography>
                  </div>
                  <div className={styles.TestimonialCardAuthor}>
                    <Typography weight="600" scale="large">{name}</Typography>
                    <Typography weight="400" scale="small">{role}</Typography>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
          {showSeeMorCard && (
            <SwiperSlide key={testimonials.length}>
              <div className={styles.TestimonialCard}>
                <div className="p_sm">
                  <ShowMoreCard reactGA={reactGA} />
                </div>
              </div>
            </SwiperSlide>
          )}
        </Swiper>
      </div>
    </div>
  );
};

export default TestimonialsMobile;
